var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChurchAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V3.75H9.5C9.08579 3.75 8.75 4.08579 8.75 4.5C8.75 4.91421 9.08579 5.25 9.5 5.25H11.25V7.38202C11.2012 7.40176 11.153 7.42349 11.1056 7.44723L6.55279 9.72362C6.214 9.89301 6 10.2393 6 10.6181V22H18V10.618C18 10.2393 17.786 9.89301 17.4472 9.72362L12.8944 7.44723C12.847 7.42349 12.7988 7.40176 12.75 7.38202V5.25H14.5C14.9142 5.25 15.25 4.91421 15.25 4.5C15.25 4.08579 14.9142 3.75 14.5 3.75H12.75V2ZM12 16C13.3807 16 14.5 17.1193 14.5 18.5V22H9.5V18.5C9.5 17.1193 10.6193 16 12 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13H3C2.44772 13 2 13.4477 2 14V21C2 21.5523 2.44772 22 3 22H4.5V13Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22H21C21.5523 22 22 21.5523 22 21V14C22 13.4477 21.5523 13 21 13H19.5V22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurchAlt);
export default __webpack_public_path__ + "static/media/church-alt.b86a12ab9bfa056d4b9dfcae6e7cb9cf.svg";
export { ForwardRef as ReactComponent };